





























































































































































































































































































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import Back from '@modules/ui/buttons/Back'
import UiList from '@superUI/List/List'
import Trigger from '@modules/ui/triggers/Trigger'
import CampaignResourceList from '@superUI/ResourceList/CampaignResourceList'
import EventResourceList from '@superUI/ResourceList/EventResourceList'
import OfferResourceList from '@superUI/ResourceList/OfferResourceList'
import PurchaseOrderResourceList from '@superUI/ResourceList/PurchaseOrderResourceList'
import InvoiceResourceList from '@superUI/ResourceList/InvoiceResourceList'
import FlagsAndTags from '@superUI/FlagsAndTags'
import SendBrandInvitationTriggerModal from '@triggers/BrandRep/SendBrandInvitationTriggerModal'
import RecessVerifyTriggerModal from '@triggers/BrandRep/RecessVerifyTriggerModal'
import RecessUnverifyTriggerModal from '@triggers/BrandRep/RecessUnverifyTriggerModal'

import DiscountTable from '@superUI/Pricing/DiscountTable'
import UpdatePricingModelDiscountTriggerModal from '@triggers/Pricing/UpdatePricingModelDiscountTriggerModal'
import RemovePricingModelDiscountTriggerModal from '@triggers/Pricing/RemovePricingModelDiscountTriggerModal'
import ChangeEmailTriggerModal from '@triggers/Member/ChangeEmailTriggerModal'
import TransferToSponsorTriggerModal from '@triggers/BrandRep/TransferToSponsorTriggerModal'
import SwitchMarketTypeTriggerModal from '@triggers/BrandRep/SwitchMarketTypeTriggerModal'
import AcceptPendingOfferTriggerModal from '@triggers/Offer/AcceptPendingOfferTriggerModal'
import SetHubspotDealTriggerModal from '@triggers/Campaign/SetHubspotDealTriggerModal'
import ExtendOffersExpirationTriggerModal from '@triggers/Offers/ExtendOffersExpirationTriggerModal'

settings =
  name: 'BrandRepShow'
  components: {
    SuperContainerView,
    Back,
    UiList,
    Trigger,
    CampaignResourceList,
    EventResourceList,
    OfferResourceList,
    PurchaseOrderResourceList,
    InvoiceResourceList,
    FlagsAndTags,
    SendBrandInvitationTriggerModal,
    RecessVerifyTriggerModal,
    RecessUnverifyTriggerModal,
    DiscountTable,
    UpdatePricingModelDiscountTriggerModal,
    RemovePricingModelDiscountTriggerModal,
    ChangeEmailTriggerModal,
    TransferToSponsorTriggerModal,
    SwitchMarketTypeTriggerModal,
    AcceptPendingOfferTriggerModal,
    SetHubspotDealTriggerModal,
    ExtendOffersExpirationTriggerModal,
  }
  resources:
    item:
      resourceName: 'brand_rep'
      slug: 'brand_reps/:brandRepId'
    campaigns:
      resourceName: 'campaign'
      slug: 'brand_reps/:brandRepId/campaigns'
      infinityScroll: true
    events:
      resourceName: 'events'
      slug: 'brand_reps/:brandRepId/events'
      infinityScroll: true
    offers:
      resourceName: 'offers'
      slug: 'brand_reps/:brandRepId/offers'
      infinityScroll: true
    brand_rep_invitations:
      resourceName: 'brand_rep_invitations'
      slug: 'brand_rep_invitations'
      fetch: false
    purchase_orders:
      resourceName: 'purchase_orders'
      slug: 'brand_reps/:brandRepId/purchase_orders'
      infinityScroll: true
    invoices:
      resourceName: 'invoices'
      slug: 'brand_reps/:brandRepId/invoices'
      infinityScroll: true

  vue:
    props: ['brandRepId']

    data: ->
      deactivateModal:
        modalOptions:
          title: 'Deactivate this brand rep'
          button:
            label: 'Deactivate'
      reactivateModal:
        modalOptions:
          title: 'Reactivate this brand rep'
          button:
            label: 'Reactivate'

      memberNoteModal:
        modalOptions:
          title: 'Add Member Note'
          inputField:
            label: 'Member Note'
            type: 'el-input'
            model: 'note'
          button:
            label: 'Add'
      superNoteModal:
        modalOptions:
          title: 'Add Super Note'
          inputField:
            label: 'Super Note'
            type: 'el-input'
            model: 'note'
          button:
            label: 'Add'

    computed:
      deactivateTriggerResource: ->
        _this = this
        { key: 'item', triggerName: 'deactivate', component: _this }
      reactivateTriggerResource: ->
        _this = this
        { key: 'item', triggerName: 'reactivate', component: _this }

      memberNoteTriggerResource: ->
        { key: 'item', triggerName: 'add_member_note', component: this }
      superNoteTriggerResource: ->
        { key: 'item', triggerName: 'add_super_note', component: this }

      publicTagTriggerResource: ->
        { key: 'item', triggerName: 'add_public_tag', component: this }
      privateTagTriggerResource: ->
        { key: 'item', triggerName: 'add_private_tag', component: this }
      untagTriggerResource: ->
        { key: 'item', triggerName: 'untag', component: this }
      privateStatusFlagTriggerResource: ->
        { key: 'item', triggerName: 'add_private_status_flag', component: this }
      unflagTriggerResource: ->
        { key: 'item', triggerName: 'unflag', component: this }

      memberNotePayload: ->
        payload =
          options:
            note: ""
        payload
      superNotePayload: ->
        payload =
          options:
            note: ""
        payload

      discountTable: -> @ctxDiscountTable(@item)
      actionsForPricingModelDiscount: ->
        {
          @hiUpdatePricingModelDiscountTrigger,
          @hiRemovePricingModelDiscountTrigger
        }

      emailsSilenced: -> @item.emails_silenced

      warningMessages: ->
        msgs = []
        msgs.push 'This rep is deactivated.' if @item.deactivated
        msgs.push 'E-mail notifications are silenced.' if @emailsSilenced
        msgs

    methods:
      badgePotential: (item) ->
        return 'unconfirmed' if item.potential_unconfirmed
        return 'confirmed' if item.potential_confirmed
        return 'denied' if item.potential_denied

      badgeState: (item) ->
        return item.state

      badgePublished: (item) ->
        if item.published then 'published' else 'unpublished'

      badgeHorizon: (item) ->
        item.horizon

      statusBadge: (event) ->
        tooltip = ''
        icon = ''
        if event.deactivated
          icon = 'fa-times'
          tooltip = 'Deactivated'
        if event.past
          icon = 'fa-history'
          tooltip = 'Past'
        if event.draft
          icon = 'fa-feather-alt'
          tooltip = 'Draft'
        if event.published
          icon = 'fa-stream'
          tooltip = 'Published'
        return false if !icon || !tooltip
        { icon, tooltip }

      originBadge: (event) ->
        tooltip = ''
        icon = ''
        if event.organizer_created
          tooltip = 'Organizer Created'
          icon = 'fa-user-ninja'
        if event.recess_projected
          tooltip = 'Recess Projected'
          icon = 'fa-magic'
        if event.recess_ghost
          tooltip = 'Recess Ghost'
          icon = 'fa-ghost'
        return false if !icon || !tooltip
        { icon, tooltip }

      hasOfferBadge: (event) ->
        tooltip = ''
        icon = 'fa-hand-holding-usd'
        if @ctxStats(event)?.offer?.count
          tooltip = 'Hass Offer'
        else
          tooltip = 'Does not have any offers'
        return false if !icon || !tooltip
        { icon, tooltip }

      verifiedBadgeSrc: (event) ->
        "#{process.env.VUE_APP_IMAGE_ENDPOINT}/indicators/recess_verified_badge.png"

      deactivateTriggerPayload: (item) ->
        payload =
          brand_reps: item.id,
        payload

      reactivateTriggerPayload: (item) ->
        payload =
          brand_reps: item.id,
        payload

      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity(state, resourceKey, data, options)

      onItemAddMemberNote: -> @fetch('item')
      onItemAddSuperNote: -> @fetch('item')
      onItemAddPublicTag: -> @fetch('item')
      onItemAddPrivateTag: -> @fetch('item')
      onItemUntag: -> @fetch('item')
      onItemAddPrivateStatusFlag: -> @fetch('item')
      onItemUnflag: -> @fetch('item')

      sendBrandInvitationTrigger: ->
        payload =
          invited_by: ''
          brand_rep_id: @item.id
        @$refs.sendBrandInvitationTrigger.fire(payload)
      onBrandRepInvitationsSendBrandInvitation: ->
        @$refs.sendBrandInvitationTrigger.close()

      recessVerifyTrigger: ->
        @$refs.recessVerifyTrigger.fire()
      onItemRecessVerify: ->
        @$refs.recessVerifyTrigger.close()

      recessUnverifyTrigger: ->
        @$refs.recessUnverifyTrigger.fire()
      onItemRecessUnverify: ->
        @$refs.recessUnverifyTrigger.close()

      hiChangeEmailTrigger: ->
        payloadOptions = {}
        modalOptions = { email: @item.email }
        @$refs.changeEmailTrigger.fire(payloadOptions, modalOptions)
      onItemChangeEmail: ->
        @$refs.changeEmailTrigger.close()
        @fetch('item')

      hiToggleEmailsSilenced: ->
        value = !@item.emails_silenced
        @triggerResource 'item', 'update_emails_silenced', { value }

      hiChangeContact: ->
        @$router.push { name: 'BrandRepTransferWizardPage', params: { brandRepId: @item.id } }

      hiSwitchMarketTypeTrigger: ->
        @$refs.switchMarketTypeTrigger.fire()
      onItemSwitchMarketType: (_, organizer) ->
        @$refs.switchMarketTypeTrigger.close()
        @$router.push { name: 'OrganizerShowPage', params: { organizerId: organizer.id } }

      hiTransferToSponsorTrigger: -> 
        payloadOptions = {}
        modalOptions = {
          currentSponsor: @item.sponsor
        }
        @$refs.transferToSponsorTrigger.fire(payloadOptions, modalOptions)
      onItemTransferToSponsor: ->
        @$refs.transferToSponsorTrigger.close()

      hiUpdatePricingModelDiscountTrigger: (pricingModel, discount) ->
        payloadOptions = { pricing_model: pricingModel }
        modalOptions = { pricing_model: pricingModel, discount }
        @$refs.updatePricingModelDiscountTrigger.fire(payloadOptions, modalOptions)
      onItemUpdatePricingModelDiscount: (data, response) ->
        @$refs.updatePricingModelDiscountTrigger.close()
        @fetch('item')

      hiRemovePricingModelDiscountTrigger: (pricingModel) ->
        payloadOptions = { pricing_model: pricingModel }
        modalOptions = { pricing_model: pricingModel }
        @$refs.removePricingModelDiscountTrigger.fire(payloadOptions, modalOptions)
      onItemRemovePricingModelDiscount: (data, response) ->
        @$refs.removePricingModelDiscountTrigger.close()
        @fetch('item')

      hiSetHubspotDealTrigger: () ->
        payloadOptions = { brand_rep_id: @item.id }
        modalOptions = { deal_id: @item.deal_id, basis: @item.basis }
        @$refs.setHubspotDealTrigger.fire payloadOptions, modalOptions
      onItemSetHubspotDeal: ->
        @$refs.setHubspotDealTrigger.close()

      hiCopyDealIdToClipboard: (event) ->
        @copyToClipboard event, @item.deal_id
        @showFlash { 'Message:': 'Copied to clipboard' }

      acceptPendingOfferTrigger: (offer) ->
        payloadOptions = { offer_id: offer.id }
        modalOptions = { offer }
        @$refs.acceptPendingOfferTrigger.fire(payloadOptions, modalOptions)
      onOffersAgreeToTermsAndAccept: ->
        @$refs.acceptPendingOfferTrigger.close()

      promptToExtendOffersExpiration: (offers) ->
        payloadOptions = { offer_ids: offers.map((o) => o.id) }
        modalOptions = {}
        @$refs.extendOffersExpirationTrigger.fire(payloadOptions, modalOptions)
      onOffersExtendOffersExpiration: ->
        @$refs.extendOffersExpirationTrigger.close()
        @$refs.offerResourceList.clearSelection()

export default VueOptions.vue settings
